import { Checkbox } from '../ui/checkbox';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider
} from '../ui/tooltip';

const PermissionCheckbox = ({ 
  checked, 
  onChange, 
  disabled, 
  permission, 
  roleName
}) => {
  const tooltipTitle = disabled 
    ? `Cannot modify system role: ${roleName}`
    : `${checked ? 'Remove' : 'Grant'} ${permission} permission for ${roleName}`;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="inline-flex items-center">
            <Checkbox
              checked={checked}
              onCheckedChange={onChange}
              disabled={disabled}
              className={disabled ? "opacity-50 cursor-not-allowed" : ""}
            />
          </div>
        </TooltipTrigger>
        <TooltipContent>
          {tooltipTitle}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default PermissionCheckbox;